"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const match_1 = require("../match");
const hooks_1 = require("../hooks");
const Redirect_1 = __importDefault(require("./Redirect"));
const Switch = ({ children }) => {
    const location = (0, hooks_1.useLocation)();
    const childList = react_1.default.Children.toArray(children)
        .filter(react_1.default.isValidElement)
        .filter(({ props, type }) => 'path' in props || type === Redirect_1.default);
    for (const child of childList) {
        if (child.type === Redirect_1.default)
            return child;
        const match = new match_1.Matcher(child.props.path).match(location);
        if (match)
            return react_1.default.cloneElement(child, { match });
    }
    return null;
};
exports.default = Switch;
